import React, { FC } from 'react';
import SearchIcon from '../../../assets/Itv/itv-search.svg';
import './ItvSearch.scss';

export const ItvSearch: FC = () => {
  return (
    <label className="itv-search">
      <img className="itv-search__icon" src={SearchIcon} alt="" aria-hidden="true" />
      <input className="itv-search__input" placeholder="Search" type="search" aria-label="Search ITV content"></input>
    </label>
  );
};
